import styled from "@emotion/styled";
import { useEffect, useRef } from "react";
import { Container } from "@mui/system";
import Player from "@vimeo/player";

export const BizcochueloFlat = () => {
  const Capsula1 = useRef(null);

  useEffect(() => {
    const capsula1Player = new Player(Capsula1.current);
    return () => {
      capsula1Player.off("ended");
    };
  }, []);

  return (
    <StyledContainer>
      <Container>
        <StyledMain>
          <StyledVideo>
            <iframe
              ref={Capsula1}
              width="100%"
              height="100%"
              src="https://player.vimeo.com/video/1186395322"
              frameBorder="0"
              allow="fullscreen; picture-in-picture"
              title="Premezclas Introducción"
              loading="lazy"
            />
          </StyledVideo>

          <StyledTexto>
            <p style={{ margin: 0, color: "#773d1e", fontSize: "1.6rem" }}>
              Haz parte de las fechas especiales con la{" "}
              <b>Premezcla para Bizcochuelo Fleischmann</b>, mira el video
              completo, responde las preguntas correctamente y podrás
              participar el próximo 30 de mayo en nuestro próximo seminario
              por un kit tecnológico por <b>4 millones de pesos</b>{" "}
              (Computador, celular y TV).
            </p>
          </StyledTexto>
        </StyledMain>

        <StyledTerminos>
          <a
            href="/images/lanzamientos/Terminosycondiciones-Bizcochuelo.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ver términos y condiciones
          </a>
        </StyledTerminos>
      </Container>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  background-color: #e5e5e5;
  min-height: calc(100vh - 64px);
  display: flex;
  align-items: center;
`;

const StyledMain = styled.div`
  padding-top: 120px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const StyledVideo = styled.div`
  width: 100%;
  aspect-ratio: 16/9;
`;

const StyledTexto = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  text-align: center;
`;

const StyledTerminos = styled.div`
  padding: 16px 0 8px;
  text-align: center;
  width: 100%;

  a {
    color: #555;
    font-size: 0.85rem;
    text-decoration: underline;

    &:hover {
      color: #222;
    }
  }
`;
